import { ReactNode } from 'react';
import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface SettingsCardProps {
    title: string;
    description?: string;
    children: ReactNode;
    footerText?: string | ReactNode;
    onSave?: () => void;
    saving?: boolean;
    disabled?: boolean;
    showFooter?: boolean;
}

export default function SettingsCard({
    title,
    description,
    children,
    footerText,
    onSave,
    saving = false,
    disabled = false,
    showFooter,
}: SettingsCardProps) {
    const { t } = useTranslation();

    const shouldRenderFooter = showFooter !== undefined ? showFooter : (Boolean(onSave) || Boolean(footerText));

    return (
        <div className="border border-gray-200 rounded-lg bg-white overflow-hidden w-full">
            <div className="p-4 sm:p-6 sm:pb-4">
                <h3 className="text-xl font-semibold mb-1 text-gray-900">{title}</h3>
                {description && (
                    <p className="text-sm text-gray-500 mb-4">{description}</p>
                )}
                <div className="w-full flex-1 space-y-4">
                    {children}
                </div>
            </div>
            
            {shouldRenderFooter && (
                <div className="bg-gray-50 px-4 py-3 sm:px-6 flex flex-row items-center justify-between border-t border-gray-200 min-h-[60px]">
                    <div className="text-sm text-gray-500 max-w-[70%]">
                        {footerText}
                    </div>
                    {onSave && (
                        <Button 
                            onClick={onSave} 
                            loading={saving} 
                            disabled={disabled}
                            color="black"
                            size="sm"
                        >
                            {t('save')}
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
}
